<script>
    export let img
    export let alt
</script>
<style>
    img {
        height: 3em;
    }
</style>
<div class="flex items-center py2 my1">
    <img class='pictogram ' src={img} alt={alt} >
    <h3 class='ml2'>
        <slot>Message</slot>
    </h3>
</div>